export default __webpack_public_path__ + "static/media/thirdPosition.978d301e.svg";